/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    BookingManagementListShow ({ commit }, data) {
        return axios.post(http + '/Spaceorder/show_orders', data).then(res => {
            return res.data
        })
    },
    AgreeBookingManagement ({ commit }, data) {
        return axios.post(http + '/Spaceorder/confirm', data).then(res => {
            return res.data
        })
    },
    cancelBookingManagement ({ commit }, data) {
        return axios.post(http + '/Spaceorder/confuse', data).then(res => {
            return res.data
        })
    },
    ExportBooking ({ commit }, data) {
        return axios({ method: 'post', url: http + '/Spaceorder/show_orders', data: data, responseType: 'blob' }).then(res => {
            return res.data
        })
    },
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const BookingManagementModule = {
    state,
    getters,
    actions,
    mutations
}
export default BookingManagementModule
